import { cn } from "@/shared/lib/utils"
import { formatScore } from "./dashboard.config"

interface ScoreDisplayProps {
  minutes: number
  className?: string
}

export function ScoreDisplay({ minutes, className }: ScoreDisplayProps) {
  const positive = minutes >= 0

  return (
    <div className={cn("flex flex-col items-center gap-1 text-center", className)}>
      <span
        className={cn(
          "font-bold text-2xl tabular-nums",
          positive ? "text-score-positive" : "text-score-negative",
        )}
      >
        {formatScore(minutes)}
      </span>
      <span className="text-muted-foreground text-xs">Jämfört med rekommenderat sömnbehov</span>
    </div>
  )
}
